import type { UDCardStyleOptions } from 'ud-ui/components/card';

/**
 * Раскладка карточки пресета, общая для `MediaManagerPresetCard` / `MediaManagerPresetPreview`
 * и их скелетона (`skeletons/preset-card-skeleton.tsx`). Живёт отдельно от карточки, чтобы
 * скелетон не тянул за собой офскрин-канву превью с плагинами fabric.
 */

/** Сетка библиотеки пресетов — та же у карточек и у скелетона. */
export const PRESET_GRID_CLASS = 'grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-4';

/**
 * Поверхность карточки пресета и шаблона группы — пропсы `UDCard`, одни у карточки и у скелетона:
 * так «Наложение» сверки не покажет сдвиг ни по полям, ни по радиусу.
 */
export const PRESET_CARD_PROPS: UDCardStyleOptions = { radius: 'panel', padding: 'sm' };

/** Раскладка содержимого карточки пресета. */
export const PRESET_CARD_LAYOUT_CLASS = 'flex flex-col gap-3';

/** Сетка карточек групп шаблонов: колонки подстраиваются под ширину, а не под брейкпоинты. */
export const GROUP_GRID_CLASS = 'grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-4';

/**
 * Поверхность карточки группы. Кликабельна не карточка, а кнопка-обложка внутри неё, поэтому `onClick`
 * в `UDCard` не передаётся — ховер тенью включает `interactive`.
 */
export const GROUP_CARD_PROPS: UDCardStyleOptions = { radius: 'panel', padding: 'none', interactive: true };

/** Раскладка содержимого карточки группы: обложка до края, поэтому `overflow-hidden`. */
export const GROUP_CARD_LAYOUT_CLASS = 'flex flex-col overflow-hidden';

/** Высота «обложки» карточки группы — одна у карточки и у её скелетона, чтобы сетка не прыгала. */
export const GROUP_COVER_CLASS = 'bg-surfaceSunken relative flex h-28 items-center justify-center';

/** Шаг иконок действий карточки. */
export const PRESET_CARD_ACTIONS_GAP = 16;

/** Квадратная рамка превью — одна и та же пока строится миниатюра и после, квадрат не меняет размер. */
export const PRESET_PREVIEW_FRAME_CLASS =
  'bg-BorderGray50 relative flex aspect-square w-full items-center justify-center overflow-hidden rounded-lg border border-gray-200';
